import { useNavigate } from "react-router-dom";
import { QueryParams } from "../../utils/types";
import { TableComponent } from "../table";
import { formatToCurrency, getMonthName } from "../../utils/helpers";
import { AdminRevenueTable } from "../../redux/features/payment/payment.types";


export const RevenueTable = ({
  fetchingRevenueData,
  revenueData,
  query,
  setQuery,
  clickable,
}: {
  fetchingRevenueData: boolean;
  revenueData?: AdminRevenueTable;
  query: QueryParams;
  setQuery: (query: QueryParams) => void;
  clickable?: boolean;
}) => {
  const navigate = useNavigate();
  return (
    <div className="w-full">
      <TableComponent
        headers={[
          "Month/Year",
          <p className="text-right">Paid Events</p>,
          <p className="text-right">Paid Tickets Sold</p>,
          // <p className="text-right">Amount Processed</p>,
          <p className="text-right"> Paid Ticket Amount</p>,
          <p className="text-right">Amount Paid</p>,
          <p className="text-right">Revenue</p>,
          <p className="text-right">Profit</p>,
        ]}
        rows={
          revenueData?.data?.data?.map((entry, idx) => {
            return {
              id: idx,
              items: [
                `${getMonthName(entry.month)} ${entry.year}`,
                <p key={`${idx}-paid-events`} className="text-right">
                  {entry?.numberOfPaidEvents}
                </p>,
                <p key={`${idx}-paid-events`} className="text-right">
                  {entry?.totalPaidTickets ?? 0}
                </p>,
                <p key={`${idx}-amount-processed`} className="text-right">
                  {formatToCurrency(entry?.amountProcessed ?? 0, {})}
                </p>,
                <p key={`${idx}-amount-paid`} className="text-right">
                  {formatToCurrency(entry?.totalAmountPaid ?? 0, {})}
                </p>,
                <p key={`${idx}-revenue`} className="text-right">
                  {formatToCurrency(entry?.revenue ?? 0, {})}
                </p>,
                <p key={`${idx}-profit`} className="text-right">
                  {formatToCurrency(entry?.profit ?? 0, {})}
                </p>,
              ],
            };
          }) ?? []
        }
        rowClassName="!text-grey-900 !font-bold"
        headerClassName="!text-grey-500 !font-bold"
        loadingRows={query.limit}
        isLoading={fetchingRevenueData}
        isRowClickable={clickable}
        onRowClick={(idx) => {
          navigate(
            `/overview/revenue/${revenueData?.data?.data[idx]?.month}/${revenueData?.data?.data[idx]?.year}`,
          );
        }}
        isTableEmpty={[0, undefined].includes(revenueData?.data?.data?.length)}
        emptyTitle="No Data"
        emptySubTitle=""
        emptyImage="/assets/images/bank-glass.png"
        currentPage={query.page ?? 1}
        totalCount={revenueData?.data?.totalCount ?? 0}
        itemsPerPage={query.limit!}
        pageRangeDisplayed={3}
        onPageChange={(page) => {
          setQuery({
            ...query,
            page: page,
          });
        }}
      />
    </div>
  );
};
